/* import __COLOCATED_TEMPLATE__ from './company-report-module.hbs'; */
import Component from '@glimmer/component';

const CLASS_NAME = 'SH-c-company-report-module';

class CompanyReportModuleComponent extends Component {
  get className() {
    return CLASS_NAME;
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get monthProjectCountChange() {
    const { projectsCountLatestFullMonth, projectsCountPreviousFullMonth } = this.args.companyLatestReportStats;
    return projectsCountLatestFullMonth - projectsCountPreviousFullMonth;
  }

  get monthSpendPercentChange() {
    const { projectsSpendLatestFullMonthInCents, projectsSpendPreviousFullMonthInCents } = this.args.companyLatestReportStats;
    const remainder = (projectsSpendLatestFullMonthInCents - projectsSpendPreviousFullMonthInCents) / projectsSpendPreviousFullMonthInCents;
    return Math.round(remainder * 100);
  }

  get monthSpendPercentChangeNotInfinity() {
    return this.args.companyLatestReportStats.projectsSpendPreviousFullMonthInCents > 0;
  }
}

export default CompanyReportModuleComponent;
